import { render, staticRenderFns } from "./defectsModal.vue?vue&type=template&id=36f777f7&"
import script from "./defectsModal.vue?vue&type=script&lang=js&"
export * from "./defectsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports